<template>
  <div class="home-v2">
    <Loading v-if="$store.state.globalLoading" />
    <ModalReview v-if="$store.state.modalReqApp.modalReview" />
    <div class="modal-level2">
      <div class="modal-level2-top">
        <Sidebar />
        <div class="level2-right">
          <transition name="component-fade" mode="out-in">
            <keep-alive>
              <component :is="activeTab" />
            </keep-alive>
          </transition>
        </div>
      </div>
      <ProfileBottom />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Sidebar: () => import('@/components/V2/ModalValidationSidebar'),
    ProfileBottom: () => import('@/components/V2/Profile-Bottom-review.vue'),
    ModalReview: () => import('@/views/Approval/reviewNote.vue'),
    Loading: () => import('@/components/V2/GlobalLoading'),
  },
  data() {
    return {
      user_id: null,
    }
  },
  async created() {
    await this.$store.dispatch('myRequest/requestDetail', this.$route.params.id)
    this.$store.commit('approvalSheet/SET_DATA', {
      name: 'request_id',
      value: this.$get(this.$route, 'params.id'),
    })
    await this.$store.commit('level1/GET_PROFILE_DATA', {
      tab: {
        name: 'profil',
        request_id: this.$get(this.$route, 'params.id'),
      },
    })
  },

  computed: {
    activeTab() {
      const tab = this.$store.state.level1.activeTab

      switch (tab) {
        case 'profil':
          return () => import('@/views/V2/Profile.vue')
          break
        case 'informasi':
          return () => import('@/views/NewTab/Informasi.vue')
          break
        case 'legaldoc':
          return () => import('@/views/NewTab/LegalDocument.vue')
          break
        default:
          break
      }
    },
  },
  methods: {},
}
</script>
